import { DayPicker } from 'react-day-picker';
import { differenceInCalendarDays, isSameDay, isAfter, startOfDay, parseISO, isBefore, max } from 'date-fns';
import 'react-day-picker/dist/style.css';
import { ko } from 'date-fns/locale';
import "../../assets/styles/components.scss"
import {useContext, useState} from "react";
import {FrontLayerContext} from "../../context/FrontLayerContext";
import {ReactComponent as CloseIcon} from "../../assets/icons/close.svg";
import {format} from "date-fns";
// 테스트 기간 임시 추가
import {AuthContext} from "../../context/AuthContext";
import useSWRImmutable from "swr/immutable";
import useSWR from "swr";

export default function DatePicker() {

  const {
    openCalendar, setOpenCalendar, onSelectDate
  } = useContext(FrontLayerContext);


  const [selected, setSelected] = useState();

  // 테스트 기간 임시 추가
  const { API_SERVER_DOMAIN, useAccessToken, fetchWithToken } = useContext(AuthContext);
  const accessToken = useAccessToken();
  const { data: user } = useSWRImmutable(accessToken && [`${API_SERVER_DOMAIN}/auth/user/check`, accessToken], fetchWithToken);
  const { data: pool } = useSWR(`${API_SERVER_DOMAIN}/pool/info`, url => fetch(url).then(res => res.json()));
  if (!user || !pool) return;

  const formatCaption = (date, options) => {
    return (
      <>
        {format(date, 'yyyy년 MM월', { locale: options?.locale })}
      </>
    );
  };

  const today = startOfDay(new Date());
  const firstBeginDate = pool?.infos?.price?.length
    ? pool.infos.price
        .map((p) => parseISO(p.beginDt))
        .reduce((minDate, curDate) => (isBefore(curDate, minDate) ? curDate : minDate))
    : today;
  const minSelectableDate = max([today, startOfDay(firstBeginDate)]);
  const closedDate = pool?.infos?.closedDate ? parseISO(pool.infos.closedDate) : null;
  const holidayDates = Array.isArray(pool?.infos?.holidays) ? pool.infos.holidays : [];
  const lastEndDate =
    pool?.infos?.price?.length ? parseISO(pool.infos.price[pool.infos.price.length - 1].endDt) : null;

  const notWithinTwoWeeks = (date) => {
    const isBeforeStart = differenceInCalendarDays(date, minSelectableDate) < 0;
    const isClosedDay = closedDate ? isSameDay(date, closedDate) : false;
    const isHoliday = holidayDates.includes(format(date, 'yyyy-MM-dd'));
    const isAfterLastEnd = lastEndDate ? isAfter(date, lastEndDate) : false;

    if ([4, 7].includes(user.userInfo.userNo)) {
      return isBeforeStart || isClosedDay || isHoliday || isAfterLastEnd;
    }

    return isBeforeStart || differenceInCalendarDays(date, minSelectableDate) > 14 || isClosedDay || isHoliday || isAfterLastEnd;
  };

  return (
    <div className={openCalendar ? "popup-show" : "popup-hide"}>
      <div className="popup-container">
        <div className="popup-header">
          <h3>예약날짜 선택</h3>
          <CloseIcon onClick={() => setOpenCalendar(false)}/>
        </div>

        <div className="date-picker-calendar">
          <DayPicker
            mode="single"
            selected={selected}
            onSelect={(val) => {
              setSelected(val);
              if (onSelectDate) onSelectDate(val);
              setOpenCalendar(false);
            }}
            locale={ko}
            formatters={{formatCaption}}
            disabled={notWithinTwoWeeks}
          />
        </div>
      </div>
    </div>
  )
}
